function toggleAccordion(header) {
    const content = header.nextElementSibling;
    const icon = header.querySelector('.icon-caret');
    const icon_circle = header.querySelector('.icon-circle_caret');
    content.classList.toggle('open');

    if (content.classList.contains('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';

        if (icon) icon.classList.add('icon-rotate');
        if (icon_circle) icon_circle.classList.add('icon-rotate');
    } else {
        content.style.maxHeight = 0;
        if (icon) icon.classList.remove('icon-rotate');
        if (icon_circle) icon_circle.classList.remove('icon-rotate');
    }
}


function scaleInnerContent() {
    const container = document.querySelector('.homepage_inner_container');
    const banner = document.querySelector('.banner_container');
  
    if (!container || !banner) return;
  
    const containerHeight = container.clientHeight;
    const bannerHeight = banner.scrollHeight;
  
    let scale = 1;
  
    if (bannerHeight > containerHeight) {
      scale = containerHeight / bannerHeight;
    }
  
    banner.style.transform = `scale(${scale})`;
  }
  
  // Run when page loads
  window.addEventListener('load', scaleInnerContent);
  // Run when window resizes
  window.addEventListener('resize', scaleInnerContent);
  